import createLucideIcon from '../createLucideIcon';

const ArrowRightCircle = createLucideIcon('ArrowRightCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['polyline', { points: '12 16 16 12 12 8', key: '1byh5s' }],
  ['line', { x1: '8', y1: '12', x2: '16', y2: '12', key: '1myapg' }],
]);

export default ArrowRightCircle;
